import {
    useEffect,
    useState,
    useCallback
} from 'react';

import deepEqual from 'deep-equal';
import { useSelector } from 'react-redux';
import i18next, { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './FavTalents.module.css';
import TalentCard from './TalentCard/TalentCard';
import Pagination from '../Pagination/Pagination';
import BlockLoader from '../../Loaders/BlockLoader';
import { SortIconList } from '../../../../assets/images/icons';
import { useGetSkillsHook } from '../../../../utils/utilityHooks';
import { getFavoriteTalents } from '../../../../services/TalentsService';

function FavTalents({ per_page, max_pages, hide_url_params = false, filters = {}, onPageChange, ...props }) {
    const navigate = useNavigate();
    const location = useLocation();

    const user = useSelector(state => state.user.user);
    const userId = useSelector(state => state.user.user.id);

    const query = new URLSearchParams(location.search);
    const initialPage = parseInt(query.get('page')) || 1;

    const [loading, setLoading] = useState(true);
    const [paginationLoading, setPaginationLoading] = useState(false);
    const [page, setPage] = useState(initialPage);
    const [filtersList, setFiltersList] = useState(filters);
    const [totalPages, setTotalPages] = useState(0);
    const [count, setCount] = useState(0);
    const [talents, setTalents] = useState([]);
    const [favTalents, setFavTalents] = useState([]);
    const [favTalentslist, setFavTalentslist] = useState([]);
    const skills = useSelector((state) => state.user.skills);
    let options = useGetSkillsHook()

    const currentLanguage = i18next.language;

    const updateURL = useCallback((params) => {
        delete params.include_ids;
        delete params.exclude_ids;

        const searchParams = new URLSearchParams(params);
        navigate(`?${searchParams.toString()}`);
    }, [navigate]);

    useEffect(() => {

        if (!deepEqual(filters, filtersList)) {
            setFiltersList(filters);
            setPage(1);

            if (!hide_url_params) {
                updateURL({ page: 1, ...filters });
            }
        }

    }, [filters, hide_url_params, filtersList, page, updateURL]);
    useEffect(() => {
        getFavoriteTalents(userId, page, per_page, filters)
            .then((response) => {
                setFavTalents(response.talents)
                setTalents(response.talents.map((talent) => {

                    if (talent.languages) {
                        talent.languages = talent.languages.map((language) => {
                            return {
                                ...language,
                                id: talent.user_id + '-' + language.languageCode
                            };
                        });
                    }

                    if (talent.skills) {
                        talent.skills = talent.skills.map((skill) => {

                            let skillData = skills?.filter((e) => e.value == skill.skill_code)[0]

                            if (skills.length > 0 && skillData && Object.keys(skillData)?.length > 0) {
                                return {
                                    ...skill,
                                    code: currentLanguage === "en" ? skillData.labelen : skillData.labelar,
                                    id: skill.user_id + '-' + skill.skill_code
                                }
                            }
                            else {
                                return {
                                    ...skill,
                                    code: skill.skill_code,
                                    id: skill.user_id + '-' + skill.skill_code
                                }
                            };
                        });
                    }
                    return talent;
                }));
                setCount(response.total);
                setTotalPages(response.totalPages);
                setLoading(false);
                setPaginationLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
        // eslint-disable-next-line
    }, [page, skills, userId, filtersList, per_page]);


    const handlePageChange = (value) => {
        setPage(value);
        setPaginationLoading(true);

        // Scroll to first card
        const target = document.querySelector('.pagination_scroll_target');
        if (target) {
            window.scrollTo(0, target.offsetTop);
        }

        if (!hide_url_params) {
            updateURL({ page: value, ...filtersList });
        }
    };
    return (
        <div {...props} className={styles.list}>
            <div className={styles.talentsHeader}>
                <div className={styles.titleContainer}>
                    <p className={styles.headerTitleBold}>{count}</p>
                    <p className={styles.headerTitle}>{t('talentsHeader.jobseekersMatchedYourCriteria')}</p>
                </div>
                <div className={styles.titleContainer}>
                    <img
                        src={SortIconList}
                        alt={t('talentsHeader.sortBy')}
                        className={styles.sortIcon}
                    />
                    <p className={styles.headerTitle}>{t('talentsHeader.sortBy')}</p>
                    <p className={styles.headerTitleBold}>{t('talentsHeader.relevanceMostRecent')}</p>
                </div>
            </div>
            {
                talents &&
                [...new Map(talents.map(talent => [talent.id, talent])).values()]
                    .map((talent) => {
                        return <TalentCard
                            setFavTalents={setFavTalents}
                            page={page} per_page={per_page} filters={filters}
                            favTalents={favTalents}

                            setTalents={setTalents} setCount={setCount} setTotalPages={setTotalPages} setLoading={setLoading}
                            setPaginationLoading={setPaginationLoading}

                            key={'talent-' + talent.id} talent={talent} disabled={paginationLoading} />;
                    })
            }

            {loading && (Array.from({ length: per_page }, (_, index) => {
                return <BlockLoader key={index} height={280} marginBottom={20} />;
            }))}

            {count === 0 && !loading && <div className={styles.no_results}>No candidates found</div>}

            {totalPages > 0 && <Pagination totalPages={totalPages} currentPage={page} onPageChange={handlePageChange} />}
        </div>
    );
}

export default FavTalents;